import { useContext } from "react";

import { showNotification } from "Helpers/Toast";

import { NotificationContext } from "Contexts/Notification";

const UseNotification = () => {
  const {
    notifications,
    regularNotifications,
    popups,
    alerts,
    hasAlerts,
    hasPendingNotifications,
    page,
    totalRows,
    getNotifications,
    readNotification,
    readNotifications,
  } = useContext(NotificationContext);

  return {
    notifications,
    regularNotifications,
    popups,
    alerts,
    hasAlerts,
    hasPendingNotifications,
    page,
    totalRows,
    getNotifications,
    readNotification,
    showNotification,
    readNotifications,
  };
};

export default UseNotification;
